import { pandaSelf, g, isBrowser } from "./globalThis";
// 确保新老的基础参数都能被覆盖，保留对象引用关系
export function init() {
    if (typeof g.__PANDA !== "object") {
        g.__PANDA = {
            cookieKey: "x-hng",
            logLevel: 2
        };
    }
    g.__PANDA.cookieKey = g.__PANDA.cookieKey || "x-hng";
    g.__PANDA.logLevel = Number.isInteger(g.__PANDA.logLevel) ? g.__PANDA.logLevel : 2;
    g._PANDA_I18N = g._PANDA_I18N || {};
    // debug的标记位
    pandaSelf.debug = typeof location !== "undefined" && !!location.search && isBrowser && location.search.includes("panda_debug=");
}
